import React, { CSSProperties, useCallback } from 'react';
import { InnoTab, InnoTabItem } from '@innomotics/innomotics-build-react-lib';

export interface Tab {
    label: string | JSX.Element | number;
    required?: boolean;
}

interface TabSwitcherProps {
    selectedTab: number;
    tabs: Tab[];
    dark?: boolean;
    layer?: 1 | 2 | 3;
    style?: CSSProperties;
    onSelect: (index: number) => void;
}

const TabSwitcher = ({ selectedTab, tabs, onSelect }: TabSwitcherProps) => {
    const handleValueChanged = useCallback((event: CustomEvent<any>) => {
        const raw = (event)?.detail?.value ?? (event)?.detail;

        const index = Number(raw);
        if (Number.isNaN(index)) return;

        if (index !== selectedTab) {
            onSelect(index);
        }
    }, [onSelect, selectedTab]);

    if (!tabs?.length) return null;

    return (
        <div className='tab-switcher-container'>
            <InnoTab
                className='inno-tab-switcher'
                layout='stretched'
                theme='dark'
                value={String(selectedTab)}
                onValueChanged={handleValueChanged}
            >
                {tabs.map((tab, index) => (
                    <InnoTabItem
                        key={index}
                        value={String(index)}
                        className={tab.required ? 'required' : undefined}
                        onClick={() => index !== selectedTab && onSelect(index)}
                    >
                        {tab.label}
                    </InnoTabItem>
                ))}
            </InnoTab>
        </div>
    );
};

export default TabSwitcher;
